//私有方法

//处理标题元素
function handleHeader(headerDom) {
  const isPushTree = {
    state:false,
    level: null
  };
  if(headerDom?.children[0]?.text){
    isPushTree.state = true;
    isPushTree.level = switchHeader(headerDom.type);
  }
  return isPushTree;
}
//处理标题元素level
function switchHeader(header) {
  let level = null;
  switch(header) {
  case "header1":
    level = 1;
    break;
  case "header2":
    level = 2;
    break;
  case "header3":
    level = 3;
    break;
  case "header4":
    level = 4;
    break;
  case "header5":
    level = 5;
    break;
  case "header6":
    level = 6;
    break;
  default:
    return false
  } 
  return level;
}
//判断当前元素插入时的前一级的等级
function judgeParentIsExist(item,prevItem,loopTimes) {
  let times = loopTimes;
  if(handleHeader(item).level > prevItem.level){
    if(prevItem.children.length > 0){
      times++;
      return  judgeParentIsExist(item,prevItem.children[prevItem.children.length-1],times);
    }else{
      return {
        loopTimes:times,
        itemLevel:handleHeader(item).level,
        parent:true,
        parentLevel:prevItem.level,
        indent:parseInt(handleHeader(item).level-(times+1))
      }
    }
  }else{
    return {
      loopTimes:times,
      parent:false,
      prevLevel:prevItem.level,
      itemLevel:handleHeader(item).level,
      indent:parseInt(handleHeader(item).level-times)
    }
  }
}
//遍历editor中返回的header列表,并递归处理目录树
function recursionHandleTree(list) {
  let menu = [];
  list.map(item=>{
    if(handleHeader(item).state){
      if(menu.length === 0){
        let itemLevel = handleHeader(item).level;
        if(handleHeader(item).level === 1){
          menu.push({label:`${item.children[0].text}`,indent:0,id:item.id,level:handleHeader(item).level,children:[]})
        }else{
          menu.push({label:`${item.children[0].text}`,indent:parseInt(itemLevel-1),id:item.id,level:handleHeader(item).level,children:[]})
        }
      }else{
        let returnData = judgeParentIsExist(item,menu[menu.length-1],1);
        let loopTimes = returnData.loopTimes;
        if(returnData.parent){
          let parent = null;
          if(loopTimes === 1){
            parent = menu[menu.length-1].children;
          }else if(loopTimes === 2){
            let grandpa = menu[menu.length-1].children;
            parent = grandpa[grandpa.length-1].children;
          }
          else if(loopTimes === 3){
            let grandpa = menu[menu.length-1].children;
            let prev = grandpa[grandpa.length-1].children;
            parent = prev[prev.length-1].children;
          }else if(loopTimes === 4){
            let grandpa = menu[menu.length-1].children;
            let prev = grandpa[grandpa.length-1].children;
            let prevParent = prev[prev.length-1].children;
            parent = prevParent[prevParent.length-1].children;
          }
          if(parent){
            parent.push({label:`${item.children[0].text}`,indent:returnData.indent,id:item.id,level:handleHeader(item).level,children:[]})
          }else{
            console.log("在有parent，出现找不到父级的情况")
          }
        }else{
          let parent = null;
          if(loopTimes === 1){
            parent = menu;
          }else if(loopTimes === 2){
            parent = menu[menu.length-1].children;
          }
          else if(loopTimes === 3){
            let grandpa = menu[menu.length-1].children;
            parent = grandpa[grandpa.length-1].children;
          }else if(loopTimes === 4){
            let grandpa = menu[menu.length-1].children;
            let prev = grandpa[grandpa.length-1].children;
            parent = prev[prev.length-1].children;
          }else if(loopTimes === 5){
            let grandpa = menu[menu.length-1].children;
            let prev = grandpa[grandpa.length-1].children;
            let prevParent = prev[prev.length-1].children;
            parent = prevParent[prevParent.length-1].children;
          }
          if(parent){
            parent.push({label:`${item.children[0].text}`,indent:returnData.indent,id:item.id,level:handleHeader(item).level,children:[]})
          }else{
            console.log("没有上一级，找不到parent的情况")
          }
        }
      }
    } 
  })
  return menu;
}
export {
  recursionHandleTree
}

